angular
    .module('empower.control')
    .directive("optselected", function () {
        return function (scope, element) {
            element.bind("change", function () {
                //alert(element.children().value);
                //alert($(element).children('option:selected').attr("actionclick"));
                var action = $(element).children('option:selected').attr("actionclick");
                scope.$apply(function () {
                    scope.$eval(action);
                    //scope.setPageName(attrs.pagename);
                });
            });
        };
    })
    .directive("defaultDivision", function () {
        return {
            link: function (scope, element) {
                var item = scope.$parent.wics;
                var matchedDivision = item.chosenDivision === scope.division.DivisionCode ? true : false;

                if (!!matchedDivision) {
                    $(element).attr('selected', '');
                }
            }
        };
    })
    .directive("defaultSubdivision", function () {
        return {
            link: function (scope, element) {
                var item = scope.$parent.wics;
                var matchedSubdivision = item.chosenSubdivision === scope.subdivision.SubdivisionCode ? true : false;

                if (!!matchedSubdivision) {
                    $(element).attr('selected', '');
                }
            }
        };
    })
    .directive("defaultGroup", function () {
        return {
            link: function (scope, element) {
                var item = scope.$parent.wics;
                var matchedGroup = item.chosenGroup === scope.group.GroupCode ? true : false;

                if (!!matchedGroup) {
                    $(element).attr('selected', '');
                }
            }
        }
    })
    .directive("defaultWiccode", function () {
        return {
            link: function (scope, element) {
                var item = scope.$parent.wics;
                var matchedWic = item.chosenWicCode === scope.code.WicCode ? true : false;

                if (!!matchedWic) {
                    $(element).attr('selected', '');
                }
            }
        }
    });
